export const MIGRATION_EMAIL_SENT = 'MIGRATION_EMAIL_SENT';

export const SAVE_PREMIUM_PLAN_SUCCEEDED = 'SAVE_PREMIUM_PLAN_SUCCEEDED';
export const SAVE_PREMIUM_PLAN_FAILED = 'SAVE_PREMIUM_PLAN_FAILED';

export const SET_INITIAL_UPGRADE_PLAN_ID = 'SET_INITIAL_UPGRADE_PLAN_ID';
export const SET_INITIAL_UPGRADE_PLAN_SUBSCRIPTION_TYPE = 'SET_INITIAL_UPGRADE_PLAN_SUBSCRIPTION_TYPE';

export const SET_INITIAL_ONBOARDING_STEP = 'SET_INITIAL_ONBOARDING_STEP';
